export enum MembershipStatus {
  /** Company has at least one active subscription (not expired). */
  ACTIVE = "ACTIVE",
  /** Company had subscription(s) but all are expired or cancelled. */
  EXPIRED = "EXPIRED",
  /** Company has no subscriptions. */
  NONE = "NONE"
}
